import { bookFerry } from "../../../api/ferries";
import * as yup from "yup";
import { paymentDispatcher } from "../../../actions/book/payment";
import { sendPixelEvent } from "../../../helpers";
import { getExchangedPrice } from "../../../umbilical_hocs";
import { v4 } from "uuid";
import { toast } from "react-toastify";
import { ferriesErrorMsgs } from "../../../errors";

function commonInitialValues(required_fields) {
  var fields = {
    is_leader: false,
    first_name: "",
    last_name: "",
    nationality: "",
    birthday: "",
  };
  if (required_fields.includes("place_of_birth")) {
    fields.place_of_birth = "";
  }
  if (required_fields.includes("passport_number")) {
    fields.passport_number = "";
  }
  if (required_fields.includes("passport_place_of_issue")) {
    fields.passport_place_of_issue = "";
  }
  if (required_fields.includes("passport_start_date")) {
    fields.passport_start_date = "";
  }
  if (required_fields.includes("passport_expiry_date")) {
    fields.passport_expiry_date = "";
  }
  if (required_fields.includes("city_code")) {
    fields.city_code = "";
  }

  return fields;
}

const adultInitialValues = {
  title: "",
};

const leaderInitialValues = {
  email: "",
  phone: "",
};

export function getInitialValues({
  adults,
  children,
  seniors,
  required_fields,
}) {
  var travellers = { adults: [], children: [], seniors: [] };

  if (adults) {
    new Array(adults).fill(1).map((x, idx) =>
      travellers.adults.push({
        ...adultInitialValues,
        ...commonInitialValues(required_fields),
        ...(idx === 0 ? { ...leaderInitialValues, is_leader: true } : {}),
        uid: v4(),
      })
    );
  }

  if (seniors) {
    new Array(seniors).fill(1).map((x, idx) =>
      travellers.seniors.push({
        ...adultInitialValues,
        ...commonInitialValues(required_fields),
        ...(adults === 0 && idx === 0
          ? { ...leaderInitialValues, is_leader: true }
          : {}),
        uid: v4(),
      })
    );
  }

  if (children) {
    new Array(children).fill(1).forEach(() =>
      travellers.children.push({
        ...commonInitialValues(required_fields),
        uid: v4(),
      })
    );
  }
  return travellers;
}

export async function initPayment({ payload, dispatch }) {
  const validationSchema = yup.object().shape({
    customer_user_data: yup.object().shape({
      first_name: yup.string().required(),
      last_name: yup.string().required(),
      email: yup.string().email().required(),
      customer_uid: yup.string(),
      nationality: yup.string().required(),
      customer_stripe_id: yup.string().nullable(),
    }),
    page_session_id: yup.string().required(),
    settedCurrency: yup.string().required(),
    amount: yup.number().required().moreThan(0),
    currency: yup.string().required(),
    reference: yup.string().required(),
  });

  try {
    await validationSchema.validate(payload, { abortEarly: false });
  } catch (error) {
    return false;
  }

  const newPrice = getExchangedPrice({
    price: payload.amount,
    priceCurrency: payload.currency,
    settedCurrency: payload.settedCurrency,
  });

  const booking_reference = payload.reference;
  const srv_type = "FER";
  const order_id = `${srv_type}___${booking_reference}`;

  const base_url = window.location.origin;
  const success_url = `${base_url}/ferries/successful-booking/${payload.page_session_id}`;
  const cancel_url = `${base_url}/ferries/${payload.page_session_id}`;
  const fail_url = `${base_url}/failed-booking/${payload.page_session_id}`;

  sendPixelEvent("InitiateCheckout", {
    data: { product_type: "ferry" },
    withPageView: false,
  });

  const {
    first_name,
    last_name,
    guest_uuid: customer_uid,
    nationality,
    email,
    customer_stripe_id,
  } = payload.customer_user_data;

  dispatch(
    paymentDispatcher({
      booking_reference,
      page_session_id: payload.page_session_id,
      amount: newPrice,
      currency: payload.settedCurrency,
      first_name,
      last_name,
      email,
      customer_uid,
      nationality,
      customer_stripe_id,
      order_id,
      success_url,
      cancel_url,
      fail_url,
      srv_type,
      source_entity: payload.source_entity,
    })
  );
  return true;
}

export async function onBooking({ payload }) {
  const validationSchema = yup.object().shape({
    session_id: yup.string().required(),
    booking_id: yup
      .mixed()
      .test(
        "is-valid-booking-id",
        "Booking ID must be a string or a number",
        (value) => {
          return typeof value === "string" || typeof value === "number";
        }
      )
      .required(),
    booking_token: yup.string().required(),
    customer_remarks: yup.string(),
    source_entity: yup.string().required(),
    website_meta: yup.object().shape({
      api_key: yup.string().required(),
      name: yup.string().required(),
    }),
    customer_user_data: yup.object().shape({
      first_name: yup.string().required(),
      last_name: yup.string().required(),
      email: yup.string().email().required(),
      customer_uid: yup.string(),
      nationality: yup.string().required(),
    }),
  });

  try {
    await validationSchema.validate(payload, {
      abortEarly: false,
    });
    const response = await bookFerry({
      payload,
      onError: (error) => {
        const err = {
          status: error.response.status,
          message: error.response.data.message,
        };
        toast.error(
          err.error.status
            ? err.error.message
            : ferriesErrorMsgs.general.unexpectedError
        );
      },
    });

    return response;
  } catch (error) {
    return null;
  }
}
